export const BASIC_INFO_FORM_TYPE = {
    name: 'name',
    roles: 'roles',
    membership: 'membership',
    about: 'about',
    headline: 'headline'
};
